<main class="blocked-version">
  <h1 class="blocked-version__title">{{ 'update.blocked.title' | translate }}</h1>
  <p class="blocked-version__subtitle">{{ 'update.blocked.subtitle' | translate }}</p>

  <div class="blocked-version__actions">
    <sz-button variant="primary" [fullWidth]="true" (click)="getApk()">
      {{ 'update.blocked.downloadCta' | translate }}
    </sz-button>
    <sz-button variant="secondary" [fullWidth]="true" (click)="goToApp()">
      {{ 'update.blocked.goToAppCta' | translate }}
    </sz-button>
  </div>

  <div class="blocked-version__versions">
    <div>{{ 'update.blocked.yourVersion' | translate }}: {{ appVersion }}</div>
    <div>{{ 'update.blocked.latestVersion' | translate }}: {{ newestVersion() }}</div>
  </div>
</main>
